module.exports = __webpack_public_path__ + "static/img/4089_phase_function_Paper_Points.0c91b84.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4089_phase_function_Paper_Points.png
// module id = rA1i
// module chunks = 0